import React, { Component } from "react";
import { TenantContractInfo } from "@eres/ejari-api/Entity/tenant";
import Strings from "@my-dld/assets/strings";
import { TenantRequestAction, TenantRequestStatus, TenantRequestUserType } from "@eres/ejari-core/constants";
import { Lookup } from "@eres/ejari-api/Entity";
import { getLocalValue } from "@eres/core/dist/LocaleValue";
import { LoadableDataState } from "@my-dld/utils/UIUtils";
import { populateLookupOnTo } from "@eres/ejari-api/Utils";
import { EjariLookUp } from "@eres/ejari-api/constants";

interface Props {
	userTypeId: string;
	contract: TenantContractInfo;
	onEdit: () => void;
}

interface State extends LoadableDataState {
	sHazards: Lookup[];
}

const LookupCache: { hazardousMaterials?: Lookup[] } = {};

class HazardsDetails extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			errorContainer: {},
			loadState: "loading",
			sHazards: [],
		};
	}

	componentDidMount() {
		const hazards = this.props.contract.HazardousMaterialClassRels;
		if ( hazards && hazards.length > 0 ) {
			const state: Partial<State> = {};
			if ( LookupCache.hazardousMaterials == null || LookupCache.hazardousMaterials.length == 0 ) {
				populateLookupOnTo( EjariLookUp.HAZARDS_MAT_CLASSIFICATION, {
					onLookup: ( lookup: EjariLookUp | string, values: Lookup[] ) => {
						LookupCache.hazardousMaterials = values;
						state.sHazards = values.filter( item => hazards.includes( item.Id ) );
						state.loadState = "done";
						this.setState( state as State );
					}
				} );
			} else {
				state.sHazards = LookupCache.hazardousMaterials.filter( item => hazards.includes( item.Id ) );
				state.loadState = "done";
				this.setState( state as State );
			}
		}
	}

	render() {
		const { userTypeId, contract, onEdit } = this.props;
		const hazards = contract.HazardousMaterialClassRels;
		if ( hazards && hazards.length > 0 ) {
			const { loadState, sHazards } = this.state;
			return <div className="card card-ui mb-4">
				<div className="card-header">
					<span>{ Strings.hazardous_material_classification }</span>
					{ userTypeId === "" + TenantRequestUserType.TENANT &&
						contract.Status === TenantRequestStatus.REQUEST_FOR_UPDATE &&
						contract.RequestActionType !== TenantRequestAction.TERMINATE &&
						<button className="btn btn-link btn-sm" type="button" onClick={ onEdit }>
							<i className="fas fa-pencil-alt me-2"/>{ Strings.edit }</button>
					}
				</div>
				<div className="card-body">
					<ul className="hazard-list row">
						{ loadState === "loading" && <span className="spinner-border"/> }
						{ sHazards.map( ( hazard: Lookup ) => {
							return <li className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12">
                                <div key={`hazard_item_${hazard.Id}`} className="form-check" >
                                    <input style={{ pointerEvents: "none" }} className="form-check-input" type="checkbox" checked={true} readOnly={true} />
                                    <label className="form-check-label" htmlFor={`hazard_item_${hazard.Id}`}>
                                        {getLocalValue(hazard)}
                                    </label>
                                </div>
							</li>;
						} ) }
					</ul>
				</div>
			</div>;
		}
		return null;
	}
}

export default HazardsDetails;
